import { SpecializedSingleSelectFilterProps } from "@components/job_search/filters/single_select_filter.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import { ClearSelectionButton } from "@components/job_search/filters/clear_selection_button.tsx";
import Divider from "@sprout/divider.tsx";
import { SecondaryButton } from "@sprout/buttons";

export const DesktopSingleSelectFilter = ({
  buttonText,
  options,
  value,
  onValueChange,
}: SpecializedSingleSelectFilterProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SecondaryButton size="medium">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <ArrowDownIcon size="sm" color="green" />
          </div>
        </SecondaryButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={0} className="pt-4 pb-6 px-6">
        <div className="w-48 text-[16px]/[1.5] text-dark-green flex flex-col gap-3">
          <ClearSelectionButton onClear={() => onValueChange("")} />
          <Divider />
          <RadioGroup value={value} onValueChange={onValueChange} className="flex flex-col gap-2">
            {options.map((option) => (
              <div key={option.value} className="flex items-center space-x-2">
                <RadioGroupItem value={option.value.toString()} id={option.value.toString()} />
                <label htmlFor={option.value.toString()} className="cursor-pointer w-full">
                  {option.label}
                </label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
